module.exports = __webpack_public_path__ + "static/img/sp_banner2.c29e278.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/sp_banner2.png
// module id = aUpG
// module chunks = 0